import React, { useRef, useImperativeHandle, forwardRef } from 'react';
import { Button } from 'takeat-design-system-ui-kit';
import { TextArea, CharCount, Footer, Header } from './styles';

const MAX_CHARS = 500;

const BuyerObservationInput = forwardRef(({ defaultValue = '', onSave, loading, readOnly = false, minHeight = '80px' }, ref) => {
  const textAreaRef = useRef(null);

  const countChars = (text) => {
    const newlines = (text.match(/\n/g) || []).length;
    return text.length + newlines;
  };

  const [charCount, setCharCount] = React.useState(() => countChars(defaultValue));
  const [isModified, setIsModified] = React.useState(false);

  useImperativeHandle(ref, () => ({
    getValue: () => textAreaRef.current?.value || '',
    setValue: (val) => {
      if (textAreaRef.current) {
        textAreaRef.current.value = val;
        setCharCount(countChars(val));
        setIsModified(false);
      }
    },
    resetModified: () => setIsModified(false),
  }));

  const handleChange = (e) => {
    const val = e.target.value;
    const count = countChars(val);
    if (count <= MAX_CHARS) {
      setCharCount(count);
      setIsModified(val !== defaultValue);
    } else {
      e.target.value = textAreaRef.current?.defaultValue || val.slice(0, -1);
    }
  };

  React.useEffect(() => {
    if (textAreaRef.current && defaultValue) {
      textAreaRef.current.value = defaultValue;
      setCharCount(countChars(defaultValue));
      setIsModified(false);
    }
  }, [defaultValue]);

  return (
    <>
      <Header>Observações internas do cliente</Header>
      <TextArea
        ref={textAreaRef}
        defaultValue={defaultValue}
        onChange={handleChange}
        placeholder="Sobre o cliente..."
        readOnly={readOnly}
        minHeight={minHeight}
      />
      {!readOnly && (
        <Footer>
          <CharCount>{charCount} / {MAX_CHARS}</CharCount>
          <Button
            size='medium'
            onClick={onSave}
            disabled={loading || !isModified}
            isLoading={loading}
            variant="outlined"
            styled={{ height: 32, padding: '0 12px', fontSize: 12 }}
          >
            Salvar
          </Button>
        </Footer>
      )}
    </>
  );
});

export default BuyerObservationInput;